import axios from 'axios';

import { Environment } from '../constants/environments';

export interface WaitlistPayload {
  username : string;
  email : string;
  phone : string;
  event_id : number;
  user_id ?: number;
}

export interface WaitlistError {
  code : 'DUPLICATE' | 'BAD_REQUEST' | 'SERVER_ERROR' | 'NETWORK' | 'GENERIC';
}

const storageKey = (eventId : number) => `waitlist_joined_${eventId}`;

export const hasJoinedWaitlist = (eventId : number): boolean =>
  Boolean(localStorage.getItem(storageKey(eventId)));

const markWaitlistJoined = (eventId : number): void => {
  localStorage.setItem(storageKey(eventId), '1');
};

export const createWaitlistEntry = async (payload : WaitlistPayload): Promise<void> => {
  try {
    await axios.post(`${Environment.API_URL}/event/waitlist?apikey=${Environment.API_KEY}`, payload);
    markWaitlistJoined(payload.event_id);
  } catch (err) {
    if (axios.isAxiosError(err)) {
      const status = err.response?.status;
      if (status === 409) throw { code : 'DUPLICATE' } as WaitlistError;
      if (status === 400) throw { code : 'BAD_REQUEST' } as WaitlistError;
      if (status && status >= 500) throw { code : 'SERVER_ERROR' } as WaitlistError;
      if (!err.response) throw { code : 'NETWORK' } as WaitlistError;
    }
    throw { code : 'GENERIC' } as WaitlistError;
  }
};

export const DDI_LIST = [
  { code : '55',  label : '+55 BR' },
  { code : '1',   label : '+1 US' },
  { code : '34',  label : '+34 ES' },
  { code : '54',  label : '+54 AR' },
  { code : '52',  label : '+52 MX' },
  { code : '351', label : '+351 PT' },
] as const;

export type DDICode = typeof DDI_LIST[number]['code'];
